module.exports = __webpack_public_path__ + "img/horizontal_6_6_8003.4234be6e.png";